import { Component } from '@angular/core';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-no-permissions',
  standalone: true,
  imports: [AlertComponent],
  template: `
    <app-alert
      styleClass="pt-1 pb-3 px-3"
      icon="fas fa-lock"
      severity="info"
      header="Keine Berechtigung"
      [canToggle]="false">
      Sie haben keine Berechtigung für diese Bereich. Bitte wenden Sie sich an
      Ihre Administrator:in.
    </app-alert>
  `,
  styles: [],
})
export class NoPermissionsComponent {}
